import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import {ChangeSet} from '@emm/core/models/change-set.model';
import {MenuDateUtil} from '@emm/core/util/menu-date.util';


const PLACEHOLDER_TEXT = 'Effective Date';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'emm-effective-date-selection',
    styleUrls: ['./effective-date-selection.component.scss'],
    templateUrl: './effective-date-selection.component.html',
    standalone: false
})
export class EffectiveDateSelectionComponent implements OnInit {

    @Input() changeSets: ChangeSet[];
    @Input() effectiveDate: string;
    @Input() label: string;
    @Input() minDate: any;
    @Input() source: 'menu' | 'reports' | 'management';
    @Input() disabled: boolean;

    @Output() effectiveDateChange = new EventEmitter<string>();

    get placeholderText() { // consider refactor for dynamic text
        if (this.label === 'Open Date') {
            return 'Select Open Date';
        } else if (this.label === 'Close Date') {
            return 'Select Close Date';
        } else if (this.label === 'End Date') {
            return 'Select End Date';
        } else {
            return 'Select Effective Date';
        }
    }

    constructor() {}

    ngOnInit(): void {
        if (!this.minDate) {
            const date = new Date();
            this.minDate = date.toISOString();
        }
    }

    onDateChanged(event: MatDatepickerInputEvent<Date>): void {
        this.effectiveDateChange.emit(event.value.toISOString());
    }

    highlightDate = (date: Date) => MenuDateUtil.getHighlightDate(this.changeSets, date);
}
